import * as React from 'react';
import { cn } from '@/lib/utils/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-gray-200 bg-transparent px-3 py-1 text-sm transition-colors',
        'file:border-0 file:bg-transparent file:font-medium file:text-sm',
        'placeholder:text-gray-400',
        'focus-visible:outline-none focus-visible:ring-[0.5px] focus-visible:ring-blue-400/60',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'dark:border-white/10 dark:focus-visible:ring-blue-400 dark:placeholder:text-gray-500',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export { Input };
